import {IntermediatePart} from "../../intermediatePart";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {toggleNotCompatibleView} from "../../../../../actions/selectionFunctions";
import {Shower} from "../../parts/shower";

export default class TubCommon extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
  }

  disabledClick() {}

  applyFeatureIfNotCompatible() {
    const showerTubComboParent = this.getParent().getParent();
    showerTubComboParent.setShowerTubCombo();
    showerTubComboParent.setActiveTub(this.partId);
  }

  handleClick(ignoreLocked, clickFrom, clickLogic = null) {
    super.handleClick(ignoreLocked);

    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }

    const showerTubComboParent = this.getParent().getParent();
    const currentBottomTub = showerTubComboParent.bottomTub;

    const showNotCompatibleViewConditions = !window.location.hash.includes("visualizer") &&
      (!showerTubComboParent.showerTubComboIsActive || (
        (this.partId === "walk_in_tub" && currentBottomTub !== "walk_in_tub") || (this.partId !== "walk_in_tub" && currentBottomTub === "walk_in_tub")
      ));

    if (showNotCompatibleViewConditions && !(clickLogic && clickLogic.skipNotCompatible)) {
      store.dispatch(toggleNotCompatibleView(true));
      return;
    }

    this.applyFeatureIfNotCompatible();
    this.featureClicked();
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    return conditions
  }

  setLayers(layout) {
    if (this.getParent().bottomTub !== this.partId) {
      super.hideLayers();
      return;
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

}
